export const FETCH_EVENTS_REQUESTED = 'analytics/FETCH_EVENTS_REQUESTED'
export const FETCH_EVENTS_SUCCEED = 'analytics/FETCH_EVENTS_SUCCEED'
export const FETCH_EVENTS_FAIL = 'analytics/FETCH_EVENTS_FAIL'

export const FETCH_TOP_PRO_LINK_REQUESTED = 'analytics/FETCH_TOP_PRO_LINK_REQUESTED'
export const FETCH_TOP_PRO_LINK_SUCCEED = 'analytics/FETCH_TOP_PRO_LINK_SUCCEED'
export const FETCH_TOP_PRO_LINK_FAIL = 'analytics/FETCH_TOP_PRO_LINK_FAIL'


export const FETCH_PRO_FUNNEL_REQUESTED = 'analytics/FETCH_PRO_FUNNEL_REQUESTED'
export const FETCH_PRO_FUNNEL_SUCCEED = 'analytics/FETCH_PRO_FUNNEL_SUCCEED'
export const FETCH_PRO_FUNNEL_FAIL = 'analytics/FETCH_PRO_FUNNEL_FAIL'

export const FETCH_STATISTIC_REQUESTED = 'analytics/FETCH_STATISTIC_REQUESTED'
export const FETCH_STATISTIC_SUCCEED = 'analytics/FETCH_STATISTIC_SUCCEED'
export const FETCH_STATISTIC_FAIL = 'analytics/FETCH_STATISTIC_FAIL'

export const FETCH_CLIENT_FUNNEL_REQUESTED = 'analytics/FETCH_CLIENT_FUNNEL_REQUESTED'
export const FETCH_CLIENT_FUNNEL_SUCCEED = 'analytics/FETCH_CLIENT_FUNNEL_SUCCEED'
export const FETCH_CLIENT_FUNNEL_FAIL = 'analytics/FETCH_CLIENT_FUNNEL_FAIL'

export const UPDATE_EVENT = 'analytics/UPDATE_EVENT'



// WEBPACK FOOTER //
// ./src/store/analytics/actionTypes.js